<template>
  <div class="select">
    <select
      v-model="selected"
      :aria-label="name"
      :title="name"
      class="select__options"
      @change="onChange"
    >
      <option
        v-for="item in list"
        :key="item"
        :aria-label="computedAriaLabel"
        :value="item"
      >
        {{ item }}
      </option>
    </select>
    <svg xmlns="http://www.w3.org/2000/svg"  width="14.956" height="8.892" class="select__svg" viewBox="0 0 14.956 8.892"><g data-name="icon/light/angle-down"><path fill="none" stroke="#808284" stroke-linecap="round" stroke-width="2" d="M13.542 1.414L7.478 7.478 1.414 1.414" /></g></svg>
  </div>
</template>

<script>
export default {
  name: 'SelectList',
  props: {
    aria: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  emits: ['changed'],
  data() {
    return {
      selected: this.value,
    };
  },
  computed: {
    computedAriaLabel() {
      return `${this.aria} ${this.selected.replace('-', ' to ')}`;
    },
  },
  methods: {
    onChange() {
      this.$emit('changed', this.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 200ms ease-in;
  font-weight: bold;

  @include hover-focus-active {
    color: $color-blue-active;

    .select__svg path { stroke: $color-blue-active; }
  }

  @include education-breakpoint-mobile-down {
    width: 100%;
    height: 2.25rem;
  }

  &__options {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent;
    border: 1px solid #C7C7C7;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 0 2rem 0 0.5rem;
    z-index: 1;
    cursor: pointer;

    &::-ms-expand { display: none; }
  }

  &__svg {
    position: absolute;
    right: 0.5rem;
  }
}
</style>
